// Localization selectors

document.querySelectorAll(".js-localization-disclosure").forEach((ld) => {
  const trigger = ld.querySelector("button");
  const options = ld.querySelectorAll("ul li");
  const input = ld.querySelector('input[type="hidden"]');

  trigger.addEventListener("click", (e) => {
    const active = ld.classList.contains("--active");
    ld.classList.toggle("--active", !active);
  });

  window.addEventListener("click", (e) => {
    if (e.target !== ld && !ld.contains(e.target)) {
      ld.classList.remove("--active");
    }
  });

  options.forEach((option) => {
    option.addEventListener("click", () => {
      input.value = option.dataset.value;
      option.closest("form")?.submit();
    });
  });
});
